import moment from 'moment';
import { DATE_FORMAT } from '@ubeeqo/web-utils';
import _ from 'lodash';

export default {
  async createEmployeeFromInvitation({
    commit,
    state,
    rootState,
  }, token) {
    const api = rootState.Setup.apiInstance;
    const parmas = { ...state.data };
    parmas.birthdate = moment(state.data.birthdate).format(DATE_FORMAT.date);
    parmas.address = state.data.address.address;
    if (!state.STATUS.LOADING) {
      commit('setStatus', 'LOADING');
      try {
        await api.createEmployeeFromInvitation(token, parmas);
        commit('resetUser');
        commit('setStatus', 'LOADED');
      } catch (error) {
        commit('setStatus', 'ERROR');
        commit('setError', error);
      }
    }
  },
  async createUser({
    commit,
    state,
    rootState,
  }) {
    const api = rootState.Setup.apiInstance;
    const params = { ...state.data };
    params.birthdate = moment(state.data.birthdate).format(DATE_FORMAT.date);
    params.address = state.data.address.address;
    params.service_country_code = state.info.country.code;
    if (!state.STATUS.LOADING) {
      commit('setStatus', 'LOADING');
      try {
        await api.createUser(params);
        commit('resetUser');
        commit('setStatus', 'LOADED');
      } catch (error) {
        commit('setStatus', 'ERROR');
        commit('setError', error);
      }
    }
  },
  async checkExistingEmail({
    commit,
    state,
    rootState,
  }) {
    const api = rootState.Setup.apiInstance;
    if (!state.STATUS.LOADING) {
      commit('setStatus', 'LOADING');
      try {
        const { data } = await api.checkExistingEmail(state.data.email);
        commit('isEmailFromCompany', data.email_from_company);
        if (data.email_from_company) {
          commit('country', data.company.country_code);
          commit('setInvitationCompany', data.company);
        }
        commit('setStatus', 'LOADED');
      } catch (error) {
        commit('setStatus', 'ERROR_EMAIL');
      }
    }
  },
  async checkInvitation({
    commit,
    state,
    rootState,
  }, {
    invitationUuid,
    invitationToken,
  }) {
    const api = rootState.Setup.apiInstance;
    if (!state.STATUS.LOADING) {
      commit('setStatus', 'LOADING');
      try {
        const { data } = await api.checkInvitation(invitationUuid, invitationToken);
        if (data.valid_invite) {
          commit('setInvitationData', data);
          commit('email', data.invite.invitee_email);
          commit('country', data.company.country_code);
          commit('setStatus', 'LOADED');
        } else {
          commit('setStatus', 'ERROR_INVITATION');
        }
      } catch (error) {
        commit('setValidInvite', false);
        commit('setStatus', 'ERROR_INVITATION');
      }
    }
  },
  async getLegalDocuments({
    commit,
    state,
    rootState,
  }) {
    const api = rootState.Setup.apiInstance;
    const uuid = _.get(state, 'info.country.default_cs_operator_uuid');

    if (!state.STATUS.LOADING) {
      commit('setStatus', 'LOADING');
      try {
        const { data } = await api.getLegalDocuments(uuid);
        const operatorDocuments = _.get(data, 'cs_operator.document', []).map(item => item.uuid);
        const genericDocuments = _.get(data, 'generic', []).map(item => item.uuid);
        commit('legalDocuments', data);
        commit('legalDocumentsAccepted', [...operatorDocuments, ...genericDocuments]);
        commit('setStatus', 'LOADED');
      } catch (error) {
        commit('setStatus', 'ERROR_LEGAL_DOCUMENTS');
      }
    }
  },
};
